import { gql } from "@apollo/client";

// ─── Economy Config Queries ──────────────────────────────────────────────────

export const GET_ECONOMY_CONFIG = gql`
  query EconomyConfig {
    economyConfig {
      _id
      key
      version
      stepTiers {
        fromSteps
        toSteps
        koinsPerThousand
      }
      dailyStepKoinsCap
      exerciseScaleFactor
      durationTiers {
        fromMinutes
        toMinutes
        rate
      }
      dailyExerciseKoinsCap
      manualSourcePenalty
      fallbackMETValue
      fairnessAgeBaseline
      fairnessAgeCoefficient
      fairnessBMIBaseline
      fairnessBMICoefficient
      fairnessMaxMultiplier
      streakRequiredDays
      streakRewardKoins
      streakMinStepsForQualifyingDay
      streakMinActivityMinutesForQualifyingDay
      challengeMinBuyIn
      challengeMaxBuyIn
      challengeMinParticipantsForPaid
      challengePrizePoolPercentage
      challengeHouseBurnPercentage
      challengeTwoPlayerWinnerPct
      challengePrizeDistribution {
        rank
        percentage
      }
      referencePricePerTenEuro
      maxManualStepsPerActivity
      maxManualDistanceKmPerActivity
      maxManualCaloriesPerActivity
      maxStepsPerMinute
      anomalyRollingMultiplier
      activityCooldownMinutes
      onboardingBonusAmount
      updatedAt
    }
  }
`;

// ─── Economy Config Mutations ────────────────────────────────────────────────

export const UPDATE_ECONOMY_CONFIG = gql`
  mutation UpdateEconomyConfig($input: UpdateEconomyConfigInput!) {
    updateEconomyConfig(input: $input) {
      _id
      version
      updatedAt
      dailyStepKoinsCap
      dailyExerciseKoinsCap
      exerciseScaleFactor
      manualSourcePenalty
      streakRequiredDays
      streakRewardKoins
      streakMinStepsForQualifyingDay
      streakMinActivityMinutesForQualifyingDay
      challengeMinBuyIn
      challengeMaxBuyIn
      challengeMinParticipantsForPaid
      challengePrizePoolPercentage
      challengeHouseBurnPercentage
      referencePricePerTenEuro
      onboardingBonusAmount
      activityCooldownMinutes
    }
  }
`;
